.tooltip-arrow-default {
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: var(--color-gray-x-hard);
  border-bottom-color: var(--color-gray-x-hard);
}

.tooltip-arrow-error {
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: var(--color-accent2);
  border-bottom-color: var(--color-accent2);
}
